/* eslint-disable
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const Auth = require('app/scripts/db/auth');
const View = require('app/scripts/views/internal/view');
const log = require('app/scripts/debug/log');
const { track } = require('@trello/analytics');
const template = require('app/scripts/views/templates/footer_chrome');

class Footer extends View {
  static initClass() {
    this.prototype.className = 'embedded-board-footer';

    this.prototype.events = { 'click .js-logout': 'logout' };
  }

  render() {
    log('render', 'rendering footer');
    this.$el.html(
      template({
        url: this.options.url,
        shouldDisplayLogout: this.options.shouldDisplayLogout,
      }),
    );
    return this;
  }

  logout() {
    if (Auth.canLogIn()) {
      Auth.logoutPost(this.options.getLogoutReturnUrl());
      return track('Log Out');
    }
  }
}

Footer.initClass();
module.exports = Footer;
